import * as types from '../common/types'
import createReducer from './createReducer'
import dayjs from 'dayjs'

const initialState = {
  historyDateRange: {
    startDate: dayjs().subtract(14, 'days'),
    endDate: dayjs(),
  },
  hoursVisible: 24,
}

export const handovers = createReducer(initialState, {
  [types.SET_CURRENT_HANDOVER](state, { data }) {
    return {
      ...state,
      current: data,
    }
  },
  [types.SET_HANDOVER_HISTORY](state, { data }) {
    return {
      ...state,
      history: data,
    }
  },
  [types.SET_HOURS_VISIBLE](state, { hours }) {
    return {
      ...state,
      hoursVisible: hours,
    }
  },
  [types.SET_HISTORY_DATE_RANGE](state, { historyDateRange }) {
    return {
      ...state,
      historyDateRange,
    }
  },
  [types.SET_LOGS_AND_NOTES](state, { payload }) {
    const history = state.history.map((handover) => {
      if (handover.id !== payload.id) return handover
      return {
        ...handover,
        ...payload,
      }
    })

    return {
      ...state,
      history,
    }
  },
})
